import { directive } from 'lit/directive.js';
import { AsyncDirective } from 'lit/async-directive.js';

class ImportCssModuleDirective extends AsyncDirective {

  constructor(part) {
    super(part);
  }

  update(_, [promise]) {
      Promise.resolve(promise)
        .then((module) => module.default)
        .then((css) => {
          this.setValue(css);
    });

    return this.value;
  }

  render() {
    return '';
  }
}

export const importCssModule = directive(ImportCssModuleDirective);


export const variables = () => importCssModule(import('./variables.css'));
export const shared = () => importCssModule(import('./shared.css'));
export const reviewShared = () => importCssModule(import('./reviewShared.css'));
export const eventsShared = () => importCssModule(import('./eventsShared.css'));
export const animations = () => importCssModule(import('./animations.css'));
export const form = () => importCssModule(import('./form.css'));
export const inputFields= () => importCssModule(import('./input-fields.css'));
export const hex = () => importCssModule(import('./hex.css'));
export const link = () => importCssModule(import('./link.css'));
export const lists = () => importCssModule(import('./lists.css'));
export const activities = () => importCssModule(import('./activities.css'));
export const profileOverview = () => importCssModule(import('./profile-overview.css'));
export const skillsPage = () => importCssModule(import('./skills-page.css'));
export const tab = () => importCssModule(import('./tab.css'));
export const material_button = () => importCssModule(import('@material/button/dist/mdc.button.min.css'));
export const material_card = () => importCssModule(import('@material/card/dist/mdc.card.min.css'));
export const material_icon_button = () => importCssModule(import('@material/icon-button/dist/mdc.icon-button.min.css'));